// Shared helpers for Cloudflare Stream video URLs/posters across the site.
export const CLOUDFLARE_CUSTOMER = 'customer-q87c1i5e2o40bvjt';

// Extracts the 32-char video ID from a full Cloudflare Stream URL.
export const getCloudflareVideoId = (urlOrId) => {
  if (!urlOrId) return null;
  const match = urlOrId.match(/cloudflarestream\.com\/([a-f0-9]+)\//);
  if (match) return match[1];
  // Already a bare ID (no domain) — accept as-is.
  return /^[a-f0-9]{32}$/i.test(urlOrId) ? urlOrId : null;
};

// Returns the still thumbnail image URL used as a <video poster> so visitors
// see a real frame instead of an empty box while the clip buffers.
export const getCloudflarePosterUrl = (urlOrId) => {
  const id = getCloudflareVideoId(urlOrId);
  if (!id) return undefined;
  return `https://${CLOUDFLARE_CUSTOMER}.cloudflarestream.com/${id}/thumbnails/thumbnail.jpg?time=&height=600`;
};
